import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import settingsDefinitionsStyles from "../styles/SettingsDefinitions.styles";

/**
 * The printable definitions sheet (PSTATS-1267, criterion 2).
 *
 * Each setting is printed with its current value beside its definition. The
 * first pass left values off, on the grounds that they were on the screen the
 * sheet was printed from - but a crew carries this to the press box away from
 * that screen, and a definition without its value cannot answer "what is this
 * game set to?". Values read the same way they do in the save confirmation
 * dialog, because core formats both.
 */
const SettingsDefinitionsSheet = ({
	heading = "Settings Definitions",
	title,
	ruleSetName,
	sections = []
}) => {
	const classes = settingsDefinitionsStyles();

	return (
		<Box className={classes.sheet}>
			<Box className={classes.sheetHeader}>
				<Typography variant="h4">{heading}</Typography>
				<Typography variant="body2" className={classes.sheetMeta}>
					{[title, ruleSetName].filter(Boolean).join(" · ")}
				</Typography>
			</Box>

			{sections.map(({ section, sectionTitle, entries }) => (
				<Box key={section} className={classes.sheetSection}>
					<Typography variant="subtitle2" className={classes.sheetSectionTitle}>
						{sectionTitle}
					</Typography>
					{entries.map(({ key, title: settingTitle, description, value }) => (
						<Box key={key} className={classes.sheetRow}>
							<Box>
								<Typography variant="body2" className={classes.sheetTerm}>
									{settingTitle}
								</Typography>
								<Typography variant="body2" className={classes.sheetValue}>
									{String(value)}
								</Typography>
							</Box>
							<Typography variant="body2">{description}</Typography>
						</Box>
					))}
				</Box>
			))}
		</Box>
	);
};

export default SettingsDefinitionsSheet;
